import type { JSX } from 'react'
import type { IRowContainerProps } from '../RowContainer.h'

import { RowSkeleton } from 'blocks/Skeletons/components/RowSkeleton/RowSkeleton'
import { LAYOUT, ROW_GAP } from 'vars/index'
import { RowContainer } from '../RowContainer'
import {
  CardsInRow,
  RowContainerVerticalGaps,
  RowControlsType,
} from '../RowContainer.h'

export interface IRowContainerTemplateProps extends IRowContainerProps {}

export const RowContainerTemplate = ({
  cardsInRow = CardsInRow.Horizontal_4,
  verticalPaddingBottom = LAYOUT.VerticalBottomRowPaddings,
  verticalPaddingTop = LAYOUT.VerticalTopRowPaddings,
  containerVerticalGap = RowContainerVerticalGaps.RowDefault,
  itemCount,
  children,
  gap = ROW_GAP.SIZE_10,
  controlsType = RowControlsType.inRowFluid,
  title,
  scrollByCardsCount,
  titleColor,
  tvChannelCard,
  buttonTitle = 'See all',
  cardAspectRatio,
  loaded = true,
  selectedItem,
  ...rest
}: IRowContainerProps): JSX.Element => {
  return loaded ? (
    <RowContainer
      gap={gap}
      verticalPaddingBottom={verticalPaddingBottom}
      verticalPaddingTop={verticalPaddingTop}
      containerVerticalGap={containerVerticalGap}
      withSpecialCell={false}
      controlsType={controlsType}
      title={title}
      scrollByCardsCount={scrollByCardsCount}
      titleColor={titleColor}
      tvChannelCard={tvChannelCard}
      itemCount={itemCount}
      buttonTitle={buttonTitle}
      cardsInRow={cardsInRow}
      cardAspectRatio={cardAspectRatio}
      selectedItem={selectedItem}
      {...rest}
    >
      {children}
    </RowContainer>
  ) : (
    <RowSkeleton cardsAspectRatio={cardAspectRatio} cardsInRow={cardsInRow} />
  )
}
